import { h } from 'preact'
import classNames from 'clsx'

import LinkWrapper from '../../atom/link-wrapper'

import styles from './index.module.scss'

const PageList = (props) => {
  const { className, inline, linkProps = {}, entries = [] } = props

  return (
    <ul className={buildClassNames({
      className,
      inline,
    })}>
      {entries.map(page => {
        const Element = page.permalink ? LinkWrapper : 'span'
        const { className, ...props } = linkProps

        return (
          <li key={page.id}
              className={styles['m-page-list__entry']}>
            <Element
              {...(page.permalink ? props : {})}
              href={page.permalink}
              className={buildLinkClassNames({
                ...(page.permalink ? props : {}),
                className,
                active: page.permalink,
              })}
            >
              {page.label}
            </Element>
          </li>
        )
      })}
    </ul>
  )
}

function buildClassNames({ className, inline }) {
  return classNames(
    className,
    styles['m-page-list'],
    { [styles['m-page-list--inline']]: inline },
  )
}

function buildLinkClassNames({ className, active }) {
  return classNames(
    className,
    styles['m-page-list__link'],
    { [styles['m-page-list__link--active']]: active },
  )
}

export default PageList
